import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";

const BlogDetail = () => {
  const { host, slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await fetch("https://gql.hashnode.com", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            query: `
              query {
                publication(host: "${host}") {
                  post(slug: "${slug}") {
                    title
                    publishedAt
                    coverImage { url }
                    content { markdown }
                  }
                }
              }
            `,
          }),
        });

        const result = await response.json();
        let markdown = result?.data?.publication?.post?.content?.markdown || "";

        // 🔹 Clean up image syntax (remove align attributes)
        markdown = markdown.replace(
          /\!\[\]\((.*?)\s+align=".*?"\)/g,
          "![]($1)"
        );

        // 🔹 Fix table pipes (if double pipes exist)
        markdown = markdown.replace(/\|\s*\|/g, "|");

        setPost({
          ...result?.data?.publication?.post,
          content: { markdown },
        });
      } catch (err) {
        console.error("Error fetching post:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [host, slug]);

  if (loading)
    return <div style={{ textAlign: "center", padding: "5rem" }}>Loading...</div>;
  if (!post)
    return <div style={{ textAlign: "center", padding: "5rem" }}>Blog not found.</div>;

  return (
    <>
      {/* Hero Section */}
      <div style={{ position: "relative", height: "100%" }}>
        {post.coverImage?.url && (
          <img
            src={post.coverImage.url}
            alt="Blog Banner"
            style={{
              marginTop: "110px",
              width: "100%",
              maxHeight: "500px",
              objectFit: "cover",
              borderBottom: "2px solid #eee",
            }}
          />
        )}
        <div
          style={{
            position: "absolute",
            bottom: "30px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "rgba(0,0,0,0.65)",
            padding: "20px 30px",
            borderRadius: "10px",
            textAlign: "center",
            color: "white",
            width: "80%",
            maxWidth: "800px",
          }}
        >
          <h1 style={{ fontSize: "2.8rem", marginBottom: "12px" }}>
            {post.title}
          </h1>
          <p style={{ margin: 0, fontSize: "1rem", opacity: "0.9" }}>
            {new Date(post.publishedAt).toDateString()}
          </p>
        </div>
      </div>

      {/* Blog Content */}
      <div
        style={{
          padding: "60px 20px",
          maxWidth: "900px",
          margin: "0 auto",
          fontFamily: "Open Sans, sans-serif",
          fontSize: "1.1rem",
          lineHeight: "1.9",
          color: "#333",
        }}
      >
        <ReactMarkdown
          children={post.content.markdown}
          components={{
            h1: ({ node, ...props }) => (
              <h1
                style={{
                  fontSize: "2.2rem",
                  marginTop: "2.5rem",
                  marginBottom: "1.2rem",
                  color: "#1a3d7c",
                  fontWeight: "700",
                }}
                {...props}
              />
            ),
            h2: ({ node, ...props }) => (
              <h2
                style={{
                  fontSize: "1.8rem",
                  marginTop: "2.2rem",
                  marginBottom: "1rem",
                  color: "#1a3d7c",
                  fontWeight: "600",
                }}
                {...props}
              />
            ),
            h3: ({ node, ...props }) => (
              <h3
                style={{
                  fontSize: "1.4rem",
                  marginTop: "1.8rem",
                  marginBottom: "0.8rem",
                  color: "#444",
                  fontWeight: "600",
                }}
                {...props}
              />
            ),
            p: ({ node, ...props }) => (
              <p style={{ marginBottom: "1.5rem" }} {...props} />
            ),
            img: ({ node, ...props }) => (
              <img
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  borderRadius: "12px",
                  margin: "2rem auto",
                  display: "block",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                }}
                {...props}
              />
            ),
            blockquote: ({ node, ...props }) => (
              <blockquote
                style={{
                  borderLeft: "4px solid #1a3d7c",
                  paddingLeft: "15px",
                  margin: "2rem 0",
                  fontStyle: "italic",
                  background: "#f9faff",
                  padding: "15px",
                  borderRadius: "6px",
                }}
                {...props}
              />
            ),
            table: ({ node, ...props }) => (
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  margin: "2rem 0",
                  fontSize: "1rem",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                }}
                {...props}
              />
            ),
            thead: ({ node, ...props }) => (
              <thead style={{ backgroundColor: "#1a3d7c", color: "#fff" }} {...props} />
            ),
            th: ({ node, ...props }) => (
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "12px",
                  fontWeight: "600",
                  textAlign: "center",
                }}
                {...props}
              />
            ),
            td: ({ node, ...props }) => (
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "12px",
                  textAlign: "center",
                }}
                {...props}
              />
            ),
            tr: ({ node, ...props }) => (
              <tr
                style={{
                  borderBottom: "1px solid #ddd",
                  backgroundColor: "white",
                }}
                {...props}
              />
            ),
          }}
        />
      </div>
    </>
  );
};

export default BlogDetail;
